import type { IconGlyph } from '../icon';

/**
 * Tractie `loader` glyph (extra small, 16×16), the icon of `tractie-loader`.
 *
 * Source: `@tractie/icons` v1.5.0 — `dist/jsx/xs/loader.jsx`.
 */
export const iconLoader: IconGlyph = {
  name: 'loader',
  path: 'M8 1a7 7 0 0 0-3.77 1.1l.73.73a6.005 6.005 0 0 1 8.22 8.22l.73.73a6.94 6.94 0 0 0 1.1-3.77c0-3.87-3.13-7-7-7Zm0 13a6.005 6.005 0 0 1-5.17-9.05l-.73-.73A6.94 6.94 0 0 0 1 7.99c0 3.87 3.13 7 7 7a7 7 0 0 0 3.77-1.1l-.73-.73c-.89.53-1.94.83-3.05.83Z',
  viewBox: 16,
};
